import _taggedTemplateLiteral from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _classCallCheck from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _get from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/Users/jeason/Documents/Todos/oxygen/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    <style>\n      :host {\n        display: block;\n        padding: 8px;\n        font-family: inherit;\n      }\n    </style>\n    <span>", "</span>\n    "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { LitElement, html } from '@polymer/lit-element/lit-element.js';
export var WiredItem =
/*#__PURE__*/
function (_LitElement) {
  _inherits(WiredItem, _LitElement);

  function WiredItem() {
    _classCallCheck(this, WiredItem);

    return _possibleConstructorReturn(this, _getPrototypeOf(WiredItem).apply(this, arguments));
  }

  _createClass(WiredItem, [{
    key: "_render",
    value: function _render(_ref) {
      var text = _ref.text;
      return html(_templateObject(), text);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this = this;

      _get(_getPrototypeOf(WiredItem.prototype), "connectedCallback", this).call(this);

      this._itemClickHandler = function (event) {
        _this._onClick(event);
      };

      this.addEventListener("click", this._itemClickHandler);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(WiredItem.prototype), "disconnectedCallback", this).call(this);

      if (this._itemClickHandler) {
        this.removeEventListener("click", this._itemClickHandler);
        this._itemClickHandler = null;
      }
    }
  }, {
    key: "_onClick",
    value: function _onClick(e) {
      var event = new CustomEvent('item-click', {
        bubbles: true,
        composed: true,
        detail: {
          text: this.text,
          value: this.value
        }
      });
      this.dispatchEvent(event);
    }
  }], [{
    key: "properties",
    get: function get() {
      return {
        text: String,
        value: String
      };
    }
  }]);

  return WiredItem;
}(LitElement);
customElements.define('wired-item', WiredItem);